import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { ExportFilteredFilesCommandArgs } from './exportFilteredFilesCommand';

const ENDPOINT = `${APIConfiguration.search}export/filteredTodos`;

async function exportFilteredTodosCommand({
  exportFormat,
  query,
  filters,
  groupedFilters,
  sortOptions,
  selectedColumns,
  dateTimeFilters,
  sellerId,
  tenantId,
  queryableFilters,
}: ExportFilteredFilesCommandArgs): Promise<
  BackResponse<string> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<string>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        query,
        filters,
        groupedFilters,
        exportFormat,
        sortOptions,
        selectedColumns,
        dateTimeFilters,
        sellerId,
        tenantId,
        queryableFilters,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default exportFilteredTodosCommand;
